<template>
  <div class="list-container">
    <div class="list">
      <div class="list-topbar d-flex justify-end align-center">
        <div class="d-flex" style="height: 40px; margin-right: 24px;">
          <div @click="changeStyle('inline')" style="cursor: pointer;">
            <v-icon
              :class="['list-view-menu', { active: style === 'inline' }]"
              size="24"
            >
              mdi-view-list
            </v-icon>
          </div>
          <div @click="changeStyle('block')" style="cursor: pointer;">
            <v-icon
              :class="['list-view-menu', { active: style === 'block' }]"
              size="24"
            >
              mdi-view-grid
            </v-icon>
          </div>
        </div>
      </div>
      <router-view> </router-view>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "ListView",
  data() {
    return {
      style: "inline",
    };
  },
  mounted() {
    this.style = this.listStyle;
  },
  computed: {
    ...mapState(["listStyle"]),
    results() {
      return this.briefs;
    },
  },
  methods: {
    ...mapMutations(["SET_LISTSTYLE"]),
    changeStyle(status) {
      this.style = status;
      this.SET_LISTSTYLE(status);
    },
  },
};
</script>

<style lang="scss">
.list-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  position: relative;

  .list {
    max-width: 1000px;
    min-width: 800px;
    width: 100%;
    height: 100%;
    padding: 10px;

    display: flex;
    flex-direction: column;
    flex-grow: 1;

    &-topbar {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      background-color: white;
      height: 72px;
      border-bottom: 1px solid rgb(232, 235, 240);

      .list-view-menu {
        height: 40px;
        padding: 10px 24px;
        border: 1px solid rgba(200, 200, 200, 1);
        color: #d8d8d8;
      }

      .list-view-menu:hover {
        background-color: #d9d9d9;
      }

      .list-view-menu.active {
        color: #000;
      }
    }

    .list-pagination {
      border-top: 1px solid #e8ebf0;
      background: white;

      .pagination-wrapper {
        position: relative;
        height: 60px;

        .pagination {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(0%, -50%);
        }

        .jump-wrapper {
          display: flex;
          align-items: center;
          position: absolute;
          top: 50%;
          right: 0;
          transform: translate(-30px, -50%);

          .jump-input {
            width: 40px;
            border: 1px solid #999999;
            outline: none;
            border-radius: 2px;
            padding: 2px 5px;
            margin: 0 5px;
          }
        }
      }
    }
  }
}
</style>
